var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 5.92949C15.5716 5.60503 15.5716 5.07896 15.2471 4.75449C14.9227 4.43002 14.3966 4.43002 14.0721 4.75449L10.0013 8.82533L5.93047 4.75449C5.606 4.43003 5.07994 4.43002 4.75547 4.75449C4.431 5.07896 4.431 5.60502 4.75547 5.92949L8.8263 10.0003L4.75547 14.0712C4.431 14.3956 4.431 14.9217 4.75547 15.2462C5.07994 15.5706 5.606 15.5706 5.93047 15.2462L10.0013 11.1753L14.0721 15.2462C14.3966 15.5706 14.9227 15.5706 15.2471 15.2462C15.5716 14.9217 15.5716 14.3956 15.2471 14.0712L11.1763 10.0003L15.2471 5.92949Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon2);
export default __webpack_public_path__ + "static/media/close_icon2.25e4245307d748cbb381f57d27a39e3d.svg";
export { ForwardRef as ReactComponent };